<template>
	<VerticalLayout>
		<StatsChartTitleWithDescription
			titleKey="stats.satellites-visibility.chartTitle"
			descriptionKey="stats.satellites-visibility.chartTitleTooltip"
			titleClass="pd-lg-x pd-md-top"
		/>
		<TimeSeriesChart :isLoading="isLoading" :series="series" :options="chartOptions" :height="500" />
	</VerticalLayout>
</template>

<script>
import { computed } from 'vue';

import Consts from '@/api/Consts';
import { getBaseOptions, generateSeries, setXAxisRange } from '@/utils/chartsUtils';
import MapHelpers from '@/components/map/utils/MapHelpers';

import VerticalLayout from '@/components/common/VerticalLayout.vue';
import TimeSeriesChart from '@/components/stats/TimeSeriesChart.vue';
import StatsChartTitleWithDescription from '@/components/stats/StatsChartTitleWithDescription.vue';


export default {
	components: {
		VerticalLayout,
		TimeSeriesChart,
		StatsChartTitleWithDescription,
	},
	props: {
		apiData: {
			type: Object,
			required: true,
		},
		isLoading: {
			type: Boolean,
			required: true,
		},
		datesRangeSafe: {
			type: Array,
			required: true,
		},
		aggFunction: {
			type: String,
			required: true,
		},
	},
	setup(props) {
		const getSeriesKey = item => {
			return MapHelpers.getGnssDataDisplay(item.client).name;
		};
		const getValue = item => item.final_value;

		const series = computed(() => generateSeries({
			items: props.apiData.statsItems,
			getSeriesKeyFn: getSeriesKey,
			getValueFn: getValue,
			seriesStep: props.apiData.period,
			showNullAsZero: false,
		}).series);

		const chartOptions = computed(() => {
			let options = getBaseOptions('satellites_visibility_count', series.value);
			setXAxisRange(options, props.datesRangeSafe);
			options.yaxis.title.text = 'Count';
			options.yaxis.decimalsInFloat = props.aggFunction === Consts.AGGREGATE_BS_SET_COUNT ? 0 : 1;
			return options;
		});

		return {
			series,
			chartOptions,
		};
	},
}
</script>
